(function () {
  'use strict';

  /* ================================================================
     CAROUSEL SETUP
  ================================================================ */
  function setupCarousel(root) {
    var currentIdx = 0;

    function getVisibleSlides() {
      return Array.from(root.querySelectorAll('.pg-carousel-slide'))
        .filter(function(s) { return s.style.display !== 'none'; });
    }
    function getVisibleDots() {
      return Array.from(root.querySelectorAll('.pg-dot'))
        .filter(function(d) { return d.style.display !== 'none'; });
    }

    function goTo(n) {
      var slides = getVisibleSlides();
      var dots   = getVisibleDots();
      if (!slides.length) return;

      root.querySelectorAll('.pg-carousel-slide').forEach(function(s) { s.classList.remove('active'); });
      root.querySelectorAll('.pg-dot').forEach(function(d) { d.classList.remove('active'); });

      currentIdx = ((n % slides.length) + slides.length) % slides.length;
      slides[currentIdx].classList.add('active');
      if (dots[currentIdx]) dots[currentIdx].classList.add('active');

      // Lazy load
      var img = slides[currentIdx].querySelector('img[data-src]');
      if (img) {
        img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      }
    }

    var btnPrev = root.querySelector('.pg-arrow-prev');
    var btnNext = root.querySelector('.pg-arrow-next');
    if (btnPrev) btnPrev.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); goTo(currentIdx - 1); });
    if (btnNext) btnNext.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); goTo(currentIdx + 1); });

    root.querySelectorAll('.pg-dot').forEach(function(dot) {
      dot.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        var idx = getVisibleDots().indexOf(dot);
        if (idx !== -1) goTo(idx);
      });
    });

    var touchStartX = 0;
    root.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function(e) {
      var delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 40) goTo(currentIdx + (delta < 0 ? 1 : -1));
    }, { passive: true });

    root._pgGoTo = goTo;
    root._pgResetFirst = function() { currentIdx = 0; goTo(0); };
    root.classList.add('pg-ready');
  }

  function initProductCarousels(scope) {
    (scope || document).querySelectorAll('.pg-carousel-root').forEach(function(root) {
      if (root.dataset.pgInit === '1') return;
      root.dataset.pgInit = '1';
      setupCarousel(root);
    });
  }

  /* ================================================================
     PARSE PRODUCT JSON — safely
  ================================================================ */
  function parseProductJson(card) {
    if (card.__pgParsed) return card.__pgParsed;
    var raw = card.dataset.jsonProduct;
    if (!raw) return null;
    try {
      var data = JSON.parse(
        raw.replace(/&quot;/g, '"')
           .replace(/&#39;/g, "'")
           .replace(/&amp;/g, '&')
           .replace(/&lt;/g, '<')
           .replace(/&gt;/g, '>')
      );
      card.__pgParsed = data;
      return data;
    } catch(e) { return null; }
  }

  /* ================================================================
     FILTER CAROUSEL BY COLOR — MAIN FUNCTION
     Sirf us variant ki images dikhao jo select ki hai
  ================================================================ */
  function filterCarouselByColor(productCard, selectedValue, swatchImgUrl) {
    console.log('[DEBUG] selectedValue received:', JSON.stringify(selectedValue));
    var root = productCard.querySelector('.pg-carousel-root');
    if (!root) return;

    // Clone ho toh init karo
    if (root.dataset.pgInit !== '1') {
      root.dataset.pgInit = '1';
      setupCarousel(root);
    }

    var allSlides = Array.from(root.querySelectorAll('.pg-carousel-slide'));
    var allDots   = Array.from(root.querySelectorAll('.pg-dot'));
    // var data      = parseProductJson(productCard);

    // Step 1: Variant ke media IDs collect karo
    // var matchedMediaIds = new Set();
    // if (data && data.variants) {
    //   data.variants.forEach(function(v) {
    //     var isMatch = [v.option1, v.option2, v.option3].some(function(opt) {
    //       if (!opt) return false;
    //       var normalized = opt.toLowerCase().replace(/\s+/g, '-');
    //       return normalized === selectedValue || opt.toLowerCase() === selectedValue;
    //     });
    //     if (isMatch && v.featured_media && v.featured_media.id) {
    //       matchedMediaIds.add(String(v.featured_media.id));
    //     }
    //   });
    // }

    // console.log('[PG] selectedValue:', selectedValue, '| matchedMediaIds:', [...matchedMediaIds]);
    // allSlides.forEach(function(s) {
    //   console.log('[PG] slide data-media-id:', s.getAttribute('data-media-id'));
    // });


    // Alt text fallback
    // if (data && data.media) {
    //   data.media.forEach(function(m) {
    //     if (m.alt && m.alt.toLowerCase().replace(/\s+/g, '-') === selectedValue) {
    //       matchedMediaIds.add(String(m.id));
    //     }
    //   });
    // }

    var matchedMediaIds = new Set();
    allSlides.forEach(function(slide) {
      var slideColor = (slide.getAttribute('data-color') || '').toLowerCase();
      if (slideColor === selectedValue) {
        matchedMediaIds.add(slide.getAttribute('data-media-id'));
      }
    });

    // Reset
    allSlides.forEach(function(s) { s.classList.remove('active'); s.style.display = ''; });
    allDots.forEach(function(d)   { d.classList.remove('active'); d.style.display = ''; });

    // Step 2: Media ID match nahi hua — direct data-img fallback
    // if (matchedMediaIds.size === 0) {
    //   if (swatchImgUrl) {
    //     var fb = root.querySelector('.pg-carousel-slide img');
    //     if (fb) { fb.src = swatchImgUrl; fb.srcset = ''; }
    //   }
    //   if (root._pgResetFirst) root._pgResetFirst();
    //   return;
    // }

//     if (matchedMediaIds.size === 0) {
//   allSlides.forEach(function(slide, i) {
//     slide.classList.toggle('active', i === 0);
//     slide.style.display = i === 0 ? '' : 'none';
//   });

//   allDots.forEach(function(dot, i) {
//     dot.classList.toggle('active', i === 0);
//     dot.style.display = i === 0 ? '' : 'none';
//   });

//   if (swatchImgUrl && allSlides[0]) {
//     var fb = allSlides[0].querySelector('img');
//     if (fb) {
//       fb.src = swatchImgUrl;
//       fb.srcset = '';
//       fb.removeAttribute('data-src');
//       fb.removeAttribute('data-srcset');
//     }
//   }

//   if (root._pgResetFirst) root._pgResetFirst();
//   return;
// }

if (matchedMediaIds.size === 0) {
  if (!selectedValue) {
    allSlides.forEach(function(slide, i) {
      slide.style.display = '';
      slide.classList.toggle('active', i === 0);
    });

    allDots.forEach(function(dot, i) {
      dot.style.display = '';
      dot.classList.toggle('active', i === 0);
    });

    if (root._pgResetFirst) root._pgResetFirst();
    return;
  }

  if (swatchImgUrl && allSlides[0]) {
    var fb = allSlides[0].querySelector('img');
    if (fb) {
      fb.src = swatchImgUrl;
      fb.srcset = '';
      fb.removeAttribute('data-src');
      fb.removeAttribute('data-srcset');
    }
  }

  allSlides.forEach(function(slide, i) {
    slide.style.display = i === 0 ? '' : 'none';
    slide.classList.toggle('active', i === 0);
  });

  allDots.forEach(function(dot, i) {
    dot.style.display = i === 0 ? '' : 'none';
    dot.classList.toggle('active', i === 0);
  });

  if (root._pgResetFirst) root._pgResetFirst();
  return;
}

    // Step 3: Slides filter karo
    var firstVisible = false;
    allSlides.forEach(function(slide, i) {
      var mediaId = String(slide.getAttribute('data-media-id') || '');
      var show = matchedMediaIds.has(mediaId);

      slide.style.display = show ? '' : 'none';
      if (allDots[i]) allDots[i].style.display = show ? '' : 'none';

      if (show && !firstVisible) {
        slide.classList.add('active');
        if (allDots[i]) allDots[i].classList.add('active');
        firstVisible = true;
      }
    });

    // Step 4: Koi slide match nahi hua — fallback
    if (!firstVisible) {
      allSlides.forEach(function(s) { s.style.display = ''; });
      allDots.forEach(function(d)   { d.style.display = ''; });
      if (swatchImgUrl) {
        var img = root.querySelector('.pg-carousel-slide img');
        if (img) { img.src = swatchImgUrl; img.srcset = ''; }
      }
    }

    if (root._pgResetFirst) root._pgResetFirst();
  }

  /* ================================================================
     SWATCH CLICK — Event Delegation
     nuranium.js ke crash ke baad bhi kaam karta hai
  ================================================================ */
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.item-swatch label');
    if (!swatch) return;

    var card = swatch.closest('.item-product');
    if (!card) return;

    // Active class
    swatch.closest('.item-swatch').querySelectorAll('label').forEach(function(l) {
      l.classList.remove('active');
    });
    swatch.classList.add('active');

    var selectedValue = (swatch.getAttribute('data-value') || '').toLowerCase().replace(/\s+/g, '-');
    var swatchImgUrl  = swatch.getAttribute('data-img') || '';

    // nuranium ke baad bhi run karo
    filterCarouselByColor(card, selectedValue, swatchImgUrl);
    setTimeout(function() {
      filterCarouselByColor(card, selectedValue, swatchImgUrl);
    }, 100);

  }, true); // useCapture:true — nuranium se PEHLE chalega

  /* ================================================================
     DEFAULT SWATCH ON LOAD
  ================================================================ */
  function applyDefaultSwatches(scope) {
    (scope || document).querySelectorAll('.item-product').forEach(function(card) {
      var active = card.querySelector('.item-swatch label.active');
      if (!active) return;
      var val = (active.getAttribute('data-value') || '').toLowerCase().replace(/\s+/g, '-');
      var img = active.getAttribute('data-img') || '';
      filterCarouselByColor(card, val, img);
    });
  }

  /* ================================================================
     SWIPER CLONE OBSERVER — naye clones ko init karo
  ================================================================ */
  function observeSwiperClones() {
    document.querySelectorAll('.swiper-wrapper').forEach(function(wrapper) {
      if (wrapper._pgObserved) return;
      wrapper._pgObserved = true;
      new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          m.addedNodes.forEach(function(node) {
            if (node.nodeType !== 1) return;
            node.querySelectorAll('.pg-carousel-root').forEach(function(root) {
              if (root.dataset.pgInit !== '1') {
                root.dataset.pgInit = '1';
                setupCarousel(root);
              }
            });
          });
        });
      }).observe(wrapper, { childList: true });
    });
  }

  /* ================================================================
     INIT
  ================================================================ */
  function run() {
    initProductCarousels();
    applyDefaultSwatches();
    observeSwiperClones();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function(e) {
    initProductCarousels(e.target);
    applyDefaultSwatches(e.target);
    observeSwiperClones();
  });

  window.pgCarouselInit = initProductCarousels;
  // window.pgSwatchInit   = function() {};
  window.pgSwatchInit = function(scope) {
    applyDefaultSwatches(scope || document);
  };
  window.filterCarouselByColor = filterCarouselByColor;

})();